module.exports = __webpack_public_path__ + "img/metatext-dashboard.8bad4367.svg";